import React, { useState } from "react";
import axios from "axios";
import {
  Form,
  Input,
  Button,
  Typography,
  Alert,
  Layout,
  notification,
  Card,
  Row,
  Col,
  Space,
} from "antd";
import { UserOutlined, LockOutlined, SafetyCertificateOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { API_ENDPOINTS } from '../../../utils/constants';
import logo from "../logo.png";

const { Title, Text } = Typography;
const { Content, Footer } = Layout;

const Login = () => {
  const [error, setError] = useState("");
  const navigate = useNavigate(); // Initialize useNavigate

  const handleSubmit = async (values) => {
    const { email, password } = values;
    try {
      const response = await axios.post(
        API_ENDPOINTS.LOGIN,
        {
          email,
          password,
        }
      );
      if (response.data.success) {
        const { token, expiresIn } = response.data;
        const expirationTime = new Date().getTime() + expiresIn * 1000; // expiresIn is in seconds
        localStorage.setItem("authToken", token);
        localStorage.setItem("sessionExpiry", expirationTime);
        notification.success({
          message: "Login Successful",
          description: "You have successfully logged in!",
          placement: "topRight",
        });
        // Redirect to dashboard
        navigate("/dashboard/home");
      } else {
        setError(response.data.message);
      }
    } catch (err) {
      notification.error({
        message: "Login Failed",
        description: "An error occurred. Please try again.",
        placement: "topRight",
      });
    }
  };

  return (
    <Layout style={{ 
      minHeight: "100vh",
      background: "#F8FAFC"
    }}>
      <Content
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          flex: 1,
          padding: "24px"
        }}
      >
        <Row justify="center" style={{ width: "100%" }}>
          <Col xs={24} sm={18} md={12} lg={8} xl={7}>
            <Card
              className="fade-in"
              style={{
                borderRadius: "16px",
                boxShadow: "0 10px 30px -10px rgba(15, 23, 42, 0.08)",
                border: "1px solid #E2E8F0",
                background: "#ffffff"
              }}
              bodyStyle={{ padding: "40px 32px" }}
            >
              {/* Header Section */}
              <div style={{ textAlign: "center", marginBottom: "32px" }}>
                <div style={{
                  background: "#4F46E5",
                  borderRadius: "16px",
                  width: "64px",
                  height: "64px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 16px"
                }}>
                  <img
                    src={logo}
                    alt="Yogi Graphics"
                    style={{
                      width: "38px",
                      height: "38px",
                      borderRadius: "8px",
                      objectFit: "contain"
                    }}
                  />
                </div>
                <Title level={3} style={{ 
                  margin: "0 0 6px",
                  color: "#0F172A",
                  fontWeight: "800",
                  fontSize: "24px",
                  letterSpacing: "-0.4px"
                }}>
                  Yogi Graphics
                </Title>
                <Text style={{ fontSize: "14px", color: "#64748B", fontWeight: "500" }}>
                  Business Management Suite
                </Text>
                <div style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "12px",
                  padding: "4px 12px",
                  background: "#F1F5F9",
                  borderRadius: "6px"
                }}>
                  <SafetyCertificateOutlined style={{ color: "#4F46E5", marginRight: "6px" }} />
                  <Text style={{ color: "#334155", fontSize: "12px", fontWeight: "600" }}>
                    Secure Portal Sign-In
                  </Text>
                </div>
              </div>

              {/* Login Form */}
              <Form
                name="login"
                onFinish={handleSubmit}
                layout="vertical"
                size="large"
              >
                <Form.Item
                  name="email"
                  label="Email Address"
                  rules={[
                    { required: true, message: "Please enter your email address" }
                  ]}
                >
                  <Input
                    prefix={<UserOutlined style={{ color: "#94A3B8" }} />}
                    placeholder="Enter email"
                    style={{
                      borderRadius: "8px",
                      border: "1px solid #CBD5E1",
                      height: "44px"
                    }}
                  />
                </Form.Item>
                
                <Form.Item
                  name="password"
                  label="Password"
                  rules={[
                    { required: true, message: "Please enter your password" }
                  ]}
                >
                  <Input.Password
                    prefix={<LockOutlined style={{ color: "#94A3B8" }} />}
                    placeholder="Enter password"
                    style={{
                      borderRadius: "8px",
                      border: "1px solid #CBD5E1",
                      height: "44px"
                    }}
                  />
                </Form.Item>

                {error && (
                  <Form.Item>
                    <Alert 
                      message={error} 
                      type="error" 
                      showIcon 
                      style={{ borderRadius: "8px" }}
                    />
                  </Form.Item>
                )}

                <Form.Item style={{ marginBottom: 0, marginTop: "20px" }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    block
                    style={{
                      height: "46px",
                      borderRadius: "8px",
                      background: "#4F46E5",
                      border: "none",
                      fontSize: "15px",
                      fontWeight: "700",
                      color: "#ffffff"
                    }}
                  >
                    Sign In
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </Col>
        </Row>
      </Content>

      <Footer
        style={{
          textAlign: "center",
          padding: "16px 24px",
          background: "transparent",
          borderTop: "none"
        }}
      >
        <Space direction="vertical" size={2}>
          <Text style={{ color: "#64748B", fontSize: "13px" }}>
            Powered by{" "}
            <a 
              href="https://clouddeveloper.in/" 
              target="_blank"
              rel="noreferrer"
              style={{ 
                color: "#4F46E5", 
                textDecoration: "none",
                fontWeight: "600"
              }}
            >
              CloudDeveloper
            </a>
          </Text>
          <Text style={{ color: "#94A3B8", fontSize: "12px" }}>
            Created by Raaj with ❤️
          </Text>
        </Space>
      </Footer>
    </Layout>
  );
};

export default Login;


